import { useCallback, useState, useMemo } from 'react';
import { DateTime } from 'luxon';
import { useMeContext } from '~/modules/me/useMeContext';

import {
  mapIsoStringtoUtcObject,
  mapRepliconDateToUtcObject
} from '~/modules/common/dates/convert';

export const ALLOCATION_POSITION = {
  FUTURE: 'FUTURE',
  PAST: 'PAST',
  CURRENT: 'CURRENT'
};

const useChangeAllocationUserAsOfDateDialogStateHandlers = ({
  resourceAllocation
}) => {
  const { currentTimeInUserTimeZone } = useMeContext();
  const { scheduleRules } = resourceAllocation;

  const [tasksChecked, setTasksChecked] = useState(true);

  const today = DateTime.fromISO(currentTimeInUserTimeZone, { setZone: true });

  const currentDate = DateTime.utc(
    today.year,
    today.month,
    today.day,
    0,
    0,
    0,
    0
  );

  const nextDate = currentDate.plus({
    days: 1
  });

  const [prevOpen, setPrevOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [changeDate, setChangeDate] = useState(nextDate);

  const [
    {
      dateRange: { startDate }
    }
  ] = scheduleRules;

  const {
    dateRange: { endDate }
  } = scheduleRules[scheduleRules.length - 1];

  const allocationStart = mapIsoStringtoUtcObject(startDate);
  const allocationEnd = mapIsoStringtoUtcObject(endDate);

  const allocationPosition =
    currentDate < allocationStart
      ? ALLOCATION_POSITION.FUTURE
      : currentDate > allocationEnd
      ? ALLOCATION_POSITION.PAST
      : ALLOCATION_POSITION.CURRENT;

  const handleOptionSelect = useCallback(id => setSelectedOption(id), [
    setSelectedOption
  ]);
  const handleDateChange = useCallback(
    date => setChangeDate(mapRepliconDateToUtcObject(date)),
    [setChangeDate]
  );

  return useMemo(
    () => ({
      setChangeDate,
      prevOpen,
      selectedOption,
      setSelectedOption,
      setPrevOpen,
      handleOptionSelect,
      handleDateChange,
      allocationStart,
      tasksChecked,
      setTasksChecked,
      allocationEnd,
      allocationPosition,
      nextDate,
      changeDate
    }),
    [
      setChangeDate,
      prevOpen,
      selectedOption,
      setSelectedOption,
      setPrevOpen,
      handleOptionSelect,
      handleDateChange,
      tasksChecked,
      setTasksChecked,
      allocationStart,
      allocationEnd,
      allocationPosition,
      nextDate,
      changeDate
    ]
  );
};

export default useChangeAllocationUserAsOfDateDialogStateHandlers;
